export default fnToRunOnReady => {
    //if using the hot reloader wait for all css and js to be added before saying document is ready;
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        window.onload = () => {
            fnToRunOnReady();
        }
        return;
    }
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        fnToRunOnReady();
    } else {
        document.addEventListener('DOMContentLoaded', fnToRunOnReady);
    }
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/on-ready.js